import { GlobalConfigType } from 'actions'
import { FieldOrigin, InputType, LoanFieldProps } from 'config'
import { store } from 'reducers'
import { FormTableHeader } from 'stories/components'

export const header: FormTableHeader[] = [
  { key: 'address', title: 'Address' },
  { key: 'borrower', title: 'Borrower' },
  { key: 'held', title: 'Held' },
  { key: 'currentUsage', title: 'Current Usage' },
  { key: 'status', title: 'Status' },
  { key: 'marketValue', title: 'Present Market Value' },
]

export const defaultInputs = (borrowerOptions: Record<number, any>): Record<string, InputType> => {
  const { globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const { [FieldOrigin.TrackRecord]: inputProps = {} } = loanFieldProperties

  const inputs: Record<string, InputType> = {
    borrower: {
      inputType: 'select',
      options: borrowerOptions,
      title: 'Borrower',
      hasDefaultOption: true,
      required: true,
    },
    held: {
      inputType: 'select',
      options: ['Jointly', 'Individually'],
      title: 'Held',
      hasDefaultOption: true,
    },
    isSubjectProperty: {
      inputType: 'check',
      title: 'This is Subject Property',
      value: false,
    },
    currentUsage: {
      inputType: 'select',
      options: ['Primary Residence', 'Second Home', 'Investment'],
      title: 'Current Usage',
      hasDefaultOption: true,
    },
    intendedUsage: {
      inputType: 'select',
      options: ['Primary Residence', 'Second Home', 'Investment', 'Other'],
      title: 'Intended Usage',
      hasDefaultOption: true,
    },
    address: {
      inputType: 'map',
      title: 'Address',
      required: true,
    },
    status: {
      inputType: 'select',
      options: ['Sold', 'Pending Sale', 'Retained - Rental', 'Retained - Non-Rental'],
      title: 'Status',
      hasDefaultOption: true,
    },
    type: {
      inputType: 'select',
      options: [
        'Single Family',
        'Condominium',
        'Townhouse',
        'Cooperative',
        'Two To Four Unit Property',
        'Multifamily More Than Four Units',
        'Manufactured Mobile Home',
        'Commercial Non Residential',
        'Mixed Use Residential',
        'Farm',
        'Home And Business Combined',
        'Land',
      ],
      title: 'Type',
      hasDefaultOption: true,
    },
    units: {
      inputType: 'text',
      type: 'thousandSepNoDecimal',
      title: 'No Units',
    },
    marketValue: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Present Market Value',
      prefix: '$',
    },
    grossRentalIncome: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Gross Rental Income',
      prefix: '$',
    },
    vacancyFactor: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Vacancy Factor',
      value: 0,
    },
    incomeLessVacancy: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Income Less Vacancy',
      prefix: '$',
      readOnly: true,
    },
    mortgagePayments: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Mortgage Payments',
      prefix: '$',
    },
    hodIncluded: {
      inputType: 'check',
      title: 'T&I/HOD Included in Mtg',
      value: false,
    },
    tiHod: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Taxes, Insurance, HOD',
      prefix: '$',
    },
    netRentalIncome: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Net Rental Income',
      prefix: '$',
      readOnly: true,
    },
    pitia: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'PITIA',
      prefix: '$',
      readOnly: true,
    },
  }

  Object.keys(inputProps)
    .filter((key) => key.startsWith('-'))
    .forEach((key) => {
      const orgKey = key.substring(1)
      if (inputProps[key] && inputProps[key].required !== undefined) inputs[orgKey].required = inputProps[key].required
    })

  return inputs
}
